import { useTranslation } from 'react-i18next';
import { Form, Select } from 'antd';
import Collapse from '../Collapse';
import { ICON } from '../Cookie/icon';
import { useState } from 'react';
import InputColor from '../../../../components/Shared/forms/InputColor';

const { Option } = Select;

const SettingStyle = ({ form }) => {
    const { t } = useTranslation();
    const [errorColor, setErrorColor] = useState(false);
    const [errorColorFont, setErrorColorFont] = useState(false);

    const checkColorFont = (_, value) => {
        if (value) {
            setErrorColorFont(false);
            return Promise.resolve();
        }
        setErrorColorFont(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };
    const checkColor = (_, value) => {
        if (value) {
            setErrorColor(false);
            return Promise.resolve();
        }
        setErrorColor(true);
        return Promise.reject(new Error(t('errorText.requiredField')));
    };
    return (
        <>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize your style')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2">
                <Collapse
                    error={errorColorFont}
                    icon={ICON.SEVEN}
                    title={t('COOKIE.FontStyle')}
                >
                    <Form.Item
                        label={
                            <div className="text-sm">{t('COOKIE.Font')}</div>
                        }
                        name={['fontFamilyPreference']}
                        className="pl-2"
                    >
                        <Select
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.children ?? '')
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                            }
                            size="large"
                            style={{ width: '100%' }}
                        >
                            <Option value="Arial">Arial (EN)</Option>
                            <Option value="Georgia">Georgia (EN)</Option>
                            <Option value="Tahoma">Tahoma (EN)</Option>
                            <Option value="Trebuchet">Trebuchet MS (EN)</Option>
                            <Option value="Verdana">Verdana (EN)</Option>
                            <Option value="Prompt">Prompt (TH-EN)</Option>
                            <Option value="Kanit">Kanit (TH-EN)</Option>
                            <Option value="Sarabun">Sarabun (TH-EN)</Option>
                            <Option value="Pridi">Pridit (TH-EN)</Option>
                            <Option value="Noto_sans">
                                Noto Sans Thai (TH-EN)
                            </Option>
                        </Select>
                    </Form.Item>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Heder')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['headerPreference', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['headerPreference', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.CookieCategoryName')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['cookieCategoryNamePreference', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['cookieCategoryNamePreference', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.CookieCategoryDescription')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={[
                                'cookieCategoryDescriptionPreference',
                                'fontSize',
                            ]}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={[
                                'cookieCategoryDescriptionPreference',
                                'color',
                            ]}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Link')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['linkPreference', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['linkPreference', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                    <div
                        className="font-semibold text-sm pt-4 pb-2"
                        style={{ borderTop: '1px solid #F2F2F2' }}
                    >
                        {t('COOKIE.Button')}
                    </div>
                    <div className="flex items-center space-x-2 pl-2">
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.Size')}
                                </div>
                            }
                            name={['buttonPreference', 'fontSize']}
                        >
                            <Select
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                                size="large"
                                style={{ width: 96 }}
                            >
                                <Option value="10px">10px</Option>
                                <Option value="12px">12px</Option>
                                <Option value="14px">14px</Option>
                                <Option value="16px">16px</Option>
                                <Option value="18px">18px</Option>
                                <Option value="20px">20px</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={
                                <div className="text-sm">
                                    {t('COOKIE.TextColor')}
                                </div>
                            }
                            name={['buttonPreference', 'color']}
                            rules={[
                                {
                                    validator: checkColorFont,
                                },
                            ]}
                        >
                            <InputColor />
                        </Form.Item>
                    </div>
                </Collapse>
                <Collapse
                    error={errorColor}
                    icon={ICON.SIX}
                    title={t('COOKIE.ThemeColor')}
                >
                    <Form.Item
                        label={
                            <div className="font-semibold  text-sm">
                                {t('COOKIE.BackgroundColor')}
                            </div>
                        }
                        name={['backgroundThemeColorPreference']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                    <Form.Item
                        label={
                            <div className="font-semibold  text-sm">
                                {t('COOKIE.CardColor')}
                            </div>
                        }
                        name={['backgroundCardColorPreference']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>

                    <Form.Item
                        label={
                            <div className="font-semibold  text-sm">
                                {t('COOKIE.ButtonColor')}
                            </div>
                        }
                        name={['buttonThemeColorPreference']}
                        rules={[
                            {
                                validator: checkColor,
                            },
                        ]}
                    >
                        <InputColor />
                    </Form.Item>
                </Collapse>
            </div>
        </>
    );
};

export default SettingStyle;
